<template>

  <v-tabs fixed-tabs icons-and-text v-model="active">
    <v-tabs-slider background-color="blue"></v-tabs-slider>

    <v-tab href="#tab-alarms">
      <v-badge right color="red" v-if="!!alarms.length">
        <span slot="badge">{{ alarms.length }}</span>
        {{ $t('map.sidebar.alarms') }}
      </v-badge>

      <v-icon>warning</v-icon>
    </v-tab>

    <v-tab href="#tab-search">
      {{ $t('map.sidebar.search') }}
      <v-icon>search</v-icon>
    </v-tab>

    <v-tab-item value="tab-alarms">
      <alarms :alarms="alarms"></alarms>
    </v-tab-item>

    <v-tab-item value="tab-search">
      <search @selected="active = 'tab-alarms'"></search>
    </v-tab-item>

  </v-tabs>

</template>

<script>

import { mapGetters } from 'vuex'
import Alarms from './alarms.vue'
import Search from './search.vue'

export default {
  name: 'tabs',

  data () {
    return {
      active: 'tab-alarms'
    }
  },

  computed: {
    ...mapGetters('map', [
      'alarms'
    ])
  },

  components: {
    Alarms,
    Search
  }
}

</script>

<style lang="scss" scoped>

</style>
